import React from 'react'
import Navbar from '../../Navbar'
import Fwcard from './Fwcard'
import Fwcardcontainer from './Fwcardcontainer'
import Fwheader from './Fwheader'
import Fwlast from './Fwlast'
import Footer from '../../Footer'
const FW = () => {
  return (
 <>
    <Navbar/>
    <Fwheader/>
    <Fwcardcontainer/>
    <Fwlast/>
    <Footer/>
    
 </>
  )
}

export default FW